<template>
  <div>
    <BaseList
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :titleAdd="$t('i18nCommon.AddEmployee')"
      :isShowStatus="true"
      @change="handleTableChange"
      @addData="addData"
      @editRow="editRow"
      @deleteRow="deleteRow"
      @onDblclick="onDblclick"
      @loadDataFilter="loadDataFilter"
    >
    </BaseList>
    <div v-if="isShow && employee && Object.keys(employee).length > 0">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.SaleEmployee") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex">
                <div class="flex-1">
                  <div class="flex columns-1">
                    <a-form-item prop="fullName" testek="name" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Name") }}
                        </div>
                        <a-input v-model:value="employee.empFullName" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item prop="phoneNumber" testek="phoneNum" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Phone") }}
                        </div>
                        <a-input v-model:value="employee.phoneNumber" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item prop="email" testek="email" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">Email</div>
                        <a-input v-model:value="employee.email" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item prop="status" testek="status" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Status") }}
                        </div>
                        <a-input v-model:value="employee.status" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                </div>
                <div class="flex flex-1 justify-center items-center">
                  <div class="logo-employee-default h-64 w-64"></div>
                </div>
              </div>
              <div class="flex columns-2 mt-6">
                <a-form-item prop="department" testek="department" class="w-full mr-8">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Department") }}
                    </div>
                    <a-input v-model:value="employee.group" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="dateOfBirth" testek="DateOfBirth" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.DateOfBirth") }}
                    </div>
                    <a-input v-model:value="employee.empDoB" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="note" testek="note" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Note") }}
                    </div>
                    <a-input v-model:value="employee.notes" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="group" testek="group" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nCommon.EmployeeInfo.Group") }}
                    </div>
                    <a-input v-model:value="employee.group" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import { mapActions, mapGetters } from "vuex";
import { ModuleEmployee } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "SaleEmployeeList",
  components: {
    BaseList,
  },
  data() {
    return {
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      employee: {},
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(ModuleEmployee, ["TotalInfo"]),
  },
  async created() {
    const me = this;
    me.initDataStatic();
    await me.loadDataGrid();
  },
  methods: {
    ...mapActions(ModuleEmployee, [
      "getEmployees",
      "updateEmployee",
      "deleteEmployee",
      "getEmployee",
    ]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        {
          fixed: "left",
          title: me.$t("i18nCommon.EmployeeInfo.Name"),
          dataIndex: "empFullName",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.empFullName, b.empFullName),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.PhoneNumber"),
          dataIndex: "phoneNumber",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.phoneNumber, b.phoneNumber),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.Code"),
          dataIndex: "empCode",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.groupCode, b.groupCode),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.DOB"),
          dataIndex: "empDoB",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.notes, b.notes),
          width: 200,
          align: "center",
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.Avatar"),
          dataIndex: "empAvatar",
          width: 200,
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.Note"),
          dataIndex: "notes",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.notes, b.notes),
          width: 200,
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.Status"),
          dataIndex: "status",
          width: 150,
          align: "center",
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.Group"),
          dataIndex: "group",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.group, b.group),
          width: 150,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.EmployeeInfo.Email"),
          dataIndex: "email",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.email, b.email),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.Action"),
          key: "rightWidgetDefault",
          fixed: "right",
          width: 150,
        },
      ];
    },

    async loadDataGrid() {
      const me = this;

      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getEmployees(payload);
    },
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getEmployees(payload);
    }, 300),

    addData() {
      const me = this;
      me.$router.push("/create-employee");
    },
    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;
      me.$router.push("/create-employee");
      setTimeout(() => {
        me.$emitter.emit("LoadEditEmployee", {
          id: dataRow.id,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteEmployeeFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteEmployeeConfirm", {
          name: dataRow.empFullName,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteEmployee({ id: dataRow.id });
          if (result && result.code == 200) {
            await me.loadDataGrid();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteEmployeeSuccess")
            );
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteEmployeeFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    async onDblclick(params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.employee = await me.getEmployee({ id: params.id });
      if (me.employee) {
        me.isShow = true;
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
